// extracted by mini-css-extract-plugin
export var heroHeaderLeft = "s_sD d_gt d_cr";
export var heroHeaderCenter = "s_gv d_gv d_cr d_dv";
export var heroHeaderRight = "s_gw d_gw d_cr d_dw";
export var heroParagraphLeft = "s_sF d_gq d_cv";
export var heroParagraphCenter = "s_gr d_gr d_cv d_dv";
export var heroParagraphRight = "s_gs d_gs d_cv d_dw";
export var heroBtnWrapperLeft = "s_sG d_d1 d_d0 d_v d_by d_bF";
export var heroBtnWrapperCenter = "s_sH d_d2 d_d0 d_v d_by d_bC";
export var heroBtnWrapperRight = "s_sJ d_d3 d_d0 d_v d_by d_bG";
export var overlayBtnWrapper = "s_sK d_gp d_Z d_6 d_7 d_8 d_bm d_cb";
export var design4 = "s_sL d_gn d_Z d_6 d_7 d_bm";
export var heroExceptionSmall = "s_rv q_rv";
export var heroExceptionNormal = "s_rw q_rw";
export var heroExceptionLarge = "s_rx q_rx";
export var Title1Small = "s_rd q_rd q_qK q_qL";
export var Title1Normal = "s_rf q_rf q_qK q_qM";
export var Title1Large = "s_rg q_rg q_qK q_qN";
export var BodySmall = "s_rp q_rp q_qK q_q2";
export var BodyNormal = "s_rq q_rq q_qK q_q3";
export var BodyLarge = "s_rr q_rr q_qK q_q4";